import React from "react";
import WspolnotaRozliczenieHistoriaTHead from "./WspolnotaRozliczenieHistoriaTHead";
import WspolnotaRozliczenieHistoriaTBody from "./WspolnotaRozliczenieHistoriaTBody";

const WspolnotaRozliczenieHistoria = props => {

    const { zaleglosciPowiadomienia, mieszkancy, udzialyKontaAkt, lokale, ulice, grupy } = props;

    return (
        <div className="historia-powiadomien">
            <div className="table-container">
                <table className="tabela historia naleznosci">
                    <WspolnotaRozliczenieHistoriaTHead />
                    <WspolnotaRozliczenieHistoriaTBody
                        zaleglosciPowiadomienia={zaleglosciPowiadomienia}
                        mieszkancy={mieszkancy}
                        udzialyKontaAkt={udzialyKontaAkt}
                        ulice={ulice}
                        lokale={lokale}
                        grupy={grupy}
                    />
                </table>
            </div>
        </div>
    )
}

export default WspolnotaRozliczenieHistoria;